<template>
  <confirm-dialog
    :show="show"
    :message="message"
    @accept="deleteSurvey"
    @close="$emit('close')">
  </confirm-dialog>
</template>
 
<script>
import EventBus from '@/event-bus';
import ConfirmDialog from '@/components/global/ConfirmDialog';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    survey: {
      type: Object,
      required: true,
    },
  },
  components: {
    ConfirmDialog,
  },
  computed: {
    message() {
      return `¿Está seguro de que desea eliminar la encuesta ${this.survey.name}? Se desactivara la encuesta para las campañas que la utilicen. Esta acción no se puede deshacer.`;
    },
  },
  methods: {
    deleteSurvey() {
      this.axios.delete(`surveys/${this.survey.id}`)
        .then(() => {
          this.$emit('deleted');
        }).catch((err) => {
          console.log(err);
          EventBus.$emit('error', 'Ocurrio un error al eliminar la encuesta');
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Surveys/DeleteDialog.vue